/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {registerLocaleData} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';
import {ErrorHandler, Injectable, LOCALE_ID, NgModule, provideZoneChangeDetection} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Router} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
	NbChatModule,
	NbDatepickerModule,
	NbDialogModule,
	NbMenuModule,
	NbSidebarModule,
	NbToastrModule,
	NbWindowModule,
} from '@nebular/theme';
import {
	MissingTranslationHandler,
	MissingTranslationHandlerParams,
	TranslateModule,
} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import {NgxEchartsModule} from 'ngx-echarts';
import {NgxFilesizeModule} from 'ngx-filesize';
import {CoreModule} from './@core/core.module';
import {AuthGuardService} from './@core/utils/auth-guard.service';
import {SessionService} from './@core/utils/session.service';
import {UnauthGuardService} from './@core/utils/unauth-guard.service';
import {ThemeModule} from './@theme/theme.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import * as echarts from 'echarts';

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
	missing = {};

	handle(params: MissingTranslationHandlerParams): string {
		this.missing[params.key] = params.key;
		return params.key;
	}
}


registerLocaleData(localeFr);
registerLocaleData(localePt);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		NgxFilesizeModule,
		NbSidebarModule.forRoot(),
		NbMenuModule.forRoot(),
		NbDatepickerModule.forRoot(),
		NbDialogModule.forRoot(),
		NbWindowModule.forRoot(),
		NbToastrModule.forRoot(),
		NbChatModule.forRoot(),
		CoreModule.forRoot(),
		ThemeModule.forRoot(),
		TranslateModule.forRoot({
			defaultLanguage: localStorage.getItem('locale') || 'FR',
			loader: provideTranslateHttpLoader({
				prefix: './assets/trads/',
				suffix: '.json',
			}),
		}),
		FontAwesomeModule,
		NgxEchartsModule.forRoot({ echarts }),
	],
	providers: [
		provideZoneChangeDetection({eventCoalescing: true}),
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		}, {
			provide: MissingTranslationHandler,
			useClass: MyMissingTranslationHandler,
		},
		{provide: LOCALE_ID, useValue: 'fr-FR'},
		AuthGuardService,
		UnauthGuardService,
		SessionService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
